// Hardened PII scrub (2026-10-01, beacons add-ons Task 2).
// Shared by clientErrorReporter (context sanitize) and homeBeacons
// (storage snapshot). Replaces/augments the old string-pattern-only guard:
//  - SENSITIVE_KEY_RE: key-drop inside object sanitizers (email/name/phone/
//    token-ish keys never reach payloads as keyed fields).
//  - Boundary-shaped email/phone scrub that never eats UUIDs: the phone
//    pattern refuses matches whose neighbours look like hex/hyphen runs
//    (UUID shape), so uuid segments survive intact.
// Pure functions; never throws.
export const SENSITIVE_KEY_RE =
  /passw|secret|token|authorization|cookie|refresh|email|e-?mail|mail|phone|tel[ef]|mobile|name|user|address|dni|curp|rfc/i;

const EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;

// Phone-like run: >=9 chars of digits/phone punctuation, starting and ending
// with a digit. Lookarounds reject matches that touch hex letters or the
// hyphen neighbours typical of UUIDs, so the 12-hex tail of a UUID is never
// matched. Trade-off: a standalone 9+ digit numeric id is treated as a phone.
const PHONE_RE = /(?<![0-9a-fA-F-])\+?\d[\d\s().-]{7,}\d(?![0-9a-fA-F-])/g;

// Two-token Title-Case human-name shape. STORAGE-SNAPSHOT USE ONLY (values
// there are ids; applying this to free text would damage prose).
const NAME_RE = /\b[A-ZÁÉÍÓÚÑÜ][a-záéíóúñü]{2,}\s+[A-ZÁÉÍÓÚÑÜ][a-záéíóúñü]{1,}\b/g;

export function scrubText(v: string): string {
  try {
    return v.replace(EMAIL_RE, '[redacted-email]').replace(PHONE_RE, '[redacted-phone]');
  } catch { return v; }
}

export function scrubNameLike(v: string): string {
  try {
    return v.replace(NAME_RE, '[redacted-name]');
  } catch { return v; }
}
